<template>
    <div>
        <h4 :class="headerClasses">
            {{ headerText }}
            <span v-if="tooltipText" class="text-sm ml-xs font-regular">
                <font-awesome-icon
                    v-tooltip.top="tooltipText"
                    icon="question-circle"
                    class="text-xs"
                />
            </span>
        </h4>
        <div class="flex flex-wrap mb-3xl">
            <div
                v-for="channel in channels"
                :key="channel.id"
                v-tooltip.top="channel.name"
                class="channel"
            >
                <img :src="channel.image" :alt="channel.name">
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            channels: {
                type: Array,
                required: true,
            },
            headerText: {
                type: String,
                required: true,
            },
            headerClass: {
                type: String,
                default: 'h4',
            },
            tooltipText: {
                type: String,
                default: '',
            },
        },
        computed: {
            headerClasses() {
                let classes = this.headerClass;

                if (this.tooltipText) {
                    classes += ' flex items-center';
                }

                return classes;
            },
        },
    };
</script>
